import { isPortalGuideScreenshotsVisible } from 'utils/portalGuideUi';

const DEFAULT_STYLE = { margin: '20px' };

export const GuideScreenshot = ({ src, alt, style = DEFAULT_STYLE }) => {
  if (!isPortalGuideScreenshotsVisible()) {
    return null;
  }

  return <img src={src} alt={alt} style={style} />;
};
